import React from 'react';
import DocumanSection from '../../../components/ai/product/DocumanSection';
import styles from "../../../styles/ai/product/AIProduct.module.css";

const AIProduct = () => {
  return (
    <main className={styles.page}>
      <DocumanSection styles={styles} />
    </main>
  )
}

export default AIProduct